export const onDownloadLinkErrorMsg = (errorMsg: string): string => {
  return `Unable to fetch download links due the following error:  ${errorMsg}`;
};
